export const FAQ_SECTIONS = [
  {
    title: 'Getting Started',
    items: [
      {
        q: 'How does the planning workflow work?',
        a: 'Start with event details, generate themes, choose the direction you like, then build the full plan. You can pause and return from the dashboard after each major step.'
      },
      {
        q: 'What happens in demo mode?',
        a: 'Demo mode creates 2 theme ideas so you can try the flow. Sign in to generate 4 themes, save plans, use credits, and build the matching event plan.'
      },
      {
        q: 'Can I change details after themes are generated?',
        a: 'Yes. Return to Details, edit the event information, then generate a fresh set when you want the themes to reflect the updated details.'
      }
    ]
  },
  {
    title: 'Themes and Credits',
    items: [
      {
        q: 'What does one planning credit include?',
        a: 'One planning credit covers one fresh theme-generation run. The matching event plan for one selected theme from that run is included.'
      },
      {
        q: 'Can I generate more themes similar to one I like?',
        a: 'That is the intended direction for theme refinement. For now, use Generate a fresh set; similar-theme expansion should be treated as a paid fresh theme run once wired.'
      },
      {
        q: 'If I plan a second theme from the same theme set, does it use another credit?',
        a: 'Recommended policy: the first plan from a theme set is included. Planning another theme from the same set should use another planning credit because it creates another full event plan.'
      }
    ]
  },
  {
    title: 'Plans and Shopping',
    items: [
      {
        q: 'Are prices and availability guaranteed?',
        a: 'No. CraftMyParty is a planning aid. Verify current prices, availability, safety, dietary needs, and venue rules before buying or hosting.'
      },
      {
        q: 'Why do you ask for ZIP code?',
        a: 'ZIP code helps with location-aware shopping, vendor relevance, local availability, and more useful in-store searches.'
      },
      {
        q: 'Are theme images exact products?',
        a: 'No. Images are visual inspiration. Actual items, colors, packaging, and availability may differ.'
      }
    ]
  },
  {
    title: 'Billing and Subscription',
    items: [
      {
        q: 'Where do I manage credits and subscription?',
        a: 'Use Billing & Credits from the side navigation or mobile bottom navigation. You can buy credits and manage, pause, or cancel your subscription there.'
      },
      {
        q: 'Do subscription credits roll over?',
        a: 'Yes. Monthly and annual subscriptions add monthly credits, and unused credits roll over.'
      },
      {
        q: 'Why does Checkout open in the same tab?',
        a: 'Stripe Checkout works best as a focused handoff in the same tab. After success or cancellation, CraftMyParty restores the screen that launched checkout.'
      }
    ]
  },
  {
    title: 'Account and Privacy',
    items: [
      {
        q: 'What happens when my session expires?',
        a: 'CraftMyParty saves a recovery snapshot when possible, hides private screens, and returns to the logged-out homepage.'
      },
      {
        q: 'Can I delete my account?',
        a: 'Yes. Account deletion is available in Settings under Account. It permanently removes your account and plans.'
      }
    ]
  }
];
